var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprayBottle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.3,12.2c0,0.2,0.1,0.3,0.3,0.3c2,0.1,3.6,1.6,4,3.5c-3,5.6-8.6,13.8-6.9,19.8c0.2,1,1.1,1.6,2.1,1.6 h13.5c1,0,1.9-0.6,2.1-1.6c1.7-6.1-3.9-14.2-6.9-19.8c0-1,0.3-1.9,0.9-2.7c0.4,1.1,1.1,2,2.1,2.5h0.4c0.3,0,0.6-0.2,0.8-0.4 c0.3-0.4,0.2-1-0.2-1.3c0,0,0,0,0,0c-0.6-0.6-0.8-1.4-0.7-2.2c0.7-0.2,1.5-0.3,2.2-0.3c0.4,0,0.7-0.3,0.7-0.7c0,0,0-0.1,0-0.1V8.4 c0.1-0.4-0.2-0.7-0.6-0.8c0,0-0.1,0-0.1,0h-9.1C18.3,7.6,16.3,9.7,16.3,12.2z M30.6,35.6c-0.1,0.7-0.7,1.1-1.4,1.1H15.8 c-0.7,0-1.3-0.4-1.4-1.1c-1.6-5.7,3.9-13.7,6.8-19.2h2.7C26.8,21.8,32.3,29.9,30.6,35.6z M29.1,8.3h0.8c0.1,0,0.1,0,0.1,0.1v2.5 c0,0.1,0,0.1-0.1,0.1h-0.8V8.3z M20.9,8.3h7.6v2.8c-2.8,0.4-4.5,1.9-4.7,4.6h-2.6c-0.4-2-2.1-3.6-4.2-3.8 C17.1,9.9,18.8,8.3,20.9,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M30.1,10.9V8.4c0-0.1,0-0.1-0.1-0.1h-0.8V11h0.8C30,11,30.1,11,30.1,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.9,11.9c2.1,0.2,3.8,1.8,4.2,3.8h2.6c0.2-2.7,1.9-4.2,4.7-4.6V8.3h-7.6C18.8,8.3,17.1,9.9,16.9,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21.1,16.4c-2.9,5.5-8.4,13.5-6.8,19.2c0.1,0.7,0.7,1.1,1.4,1.1h13.5c0.7,0,1.3-0.4,1.4-1.1 c1.6-5.7-3.9-13.8-6.8-19.2H21.1z M22.6,32.3c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2S24.9,32.3,22.6,32.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4AB8DC",
    cx: 22.6,
    cy: 28.1,
    r: 4.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprayBottle);
export default __webpack_public_path__ + "static/media/spray_bottle.d2c13de7f5ee58f1fa4bc478bc69114a.svg";
export { ForwardRef as ReactComponent };